import { createContext } from 'react';

/**
 * Opens the release notes from anywhere in the app shell, such as the user menu;
 * `null` while this deployment publishes none.
 */
export const ReleaseNotesOpenerCtx = createContext<(() => void) | null>(null);
